import React, { useEffect, useState } from 'react';
import ViewTabs from '../../../components/Portfolio/ViewTabs';
import PortfolioContainer from '../../../components/Portfolio/PortfolioContainer';
import './index.css';
import Details from './Details';
import Documents from './Documents';
import QueryList from './QueryList';
import Statemanage from '../../../config/StateContext';
import LenderDemand from './LenderDemand';
import AdditionalInformation from './AdditionalInfo';
import AuditTrail from './AudtiTrail';
import Routing from '../../../router/Routing';
import { useParams, useLocation } from 'react-router';
import { Context } from '../../../config/store';
import LenderUgroService from '../../../services/lender';
import MasterDataService from '../../../services/master-data';
import PortfolioActions from './PortfolioActions';
import Button from '../../../components/Common/Button';
import { Link, useNavigate } from 'react-router-dom';
import { objectsForEach } from '../../../common/objectToArray';
import ConditionalApprove from './ConditionalApprove'
import DRF from '../DRF';
import Mandate from './Mandate';
import AssignLenderLeadModal from '../../../components/Portfolio/AssignLenderLeadModal';
import FundOut from './fundout';
import RepaymentSchedule from './RepaymentSchedule';
import RepaymentDetails from '../PostDisbursalCaseView/RepaymentDetails';
import SoaDocumentView from '../PostDisbursalCaseView/SoaDocumentVIew';
import PullBackModal from './PullBackModal';
import PayToCustomer from './PayToCustomer';
import { toast } from 'react-toastify';

export default function ViewPortfolio() {
	// const { Buttonmanage } = React.useContext(Statemanage);
	const { state, dispatch } = React.useContext(Context);
	const [leadInfo, setLeadInfo] = React.useState();
	const [viewPage, setViewPage] = React.useState([]);
	const [lenders, setLenders] = React.useState([]);
	const [leadInfoError, setLeadInfoError] = React.useState(false);
	const [lenderInfoLoading, setLenderInfoLoading] = React.useState(false);
	const [leadInfoErrorMessage, setLeadInfoErrorMessage] = React.useState('');
	const [selectedLender, setSelectedLender] = React.useState(null);
	const [selectedLenderName, setSelectedLenderName] = React.useState(null);
	const [allSelected, toggleAllSelection] = React.useState(false);
	const [assignModalState, setAssignModalState] = React.useState(false);
	const [selectedColender, setselectedColender] = useState(localStorage.getItem('selectedColender'))
	const location = useLocation();
	const navigate = useNavigate();
	const [QueryLenderId, setQuerylenderId] = useState(null);
	const [LAF, setLAF] = useState('')
	const portfolioId = useParams()['id'];
	const params = useParams();
	const [isPoolFilter, setIsPoolFilter] = React.useState(localStorage.getItem('isPoolFilter'))
	const [isDaPending, setIsDaPending] = React.useState(localStorage.getItem('isDaPending'))
	const [batchId, setBatchId] = React.useState(localStorage.getItem('batchid'))
	const [showPullBackConfirm, setShowPullBackConfirm] = React.useState(false);
	const [showRejectModal, setShowRejectModal] = React.useState(false);
	const [showFetchBtn, setShowFetchBtn] = React.useState(false)
	const [fetchLoader, setFetchLoader] = React.useState(false)
	const [pageLoader, setPageLoader] = React.useState(true)
	const allowedIds = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];

	React.useLayoutEffect(() => {
		if (selectedLender || allSelected) {
			getLeadDetail();
		}
	}, [selectedLender]);

	const getLeadDetail = async (lenderId) => {
		try {
			const response = await LenderUgroService.getPortfolioDetail({
				type: state.userType,
				leadId: portfolioId,
				lenderId: lenderId ? lenderId : allSelected ? 0 : selectedLender,
			});
			const hasMatchingId = response?.data?.data?.details?.cl_lead_status?.some(item => allowedIds?.includes(item?.id));
			if (hasMatchingId) {
				setShowFetchBtn(true)
			}
			setLeadInfo(response?.data?.data?.details);
		} catch (err) {
			console.log('KEEP SILENCE......');
		}
	};

	React.useLayoutEffect(() => {
		getLenderList();
	}, [leadInfo?.cl_lead?.lead_type]);

	React.useLayoutEffect(() => {
		pageLoader && setTimeout(() => {
			setPageLoader(false)
		}, 2000);
	}, [pageLoader]);

	const getLenderList = async () => {
		setLeadInfoError(false);
		setLenderInfoLoading(true);
		try {
			const response = await MasterDataService.getLenderListByLeadId(
				'admin',
				'co-lender',
				portfolioId
			);
			if (response?.data?.status?.code === 1) {
				let responseList = objectsForEach(
					response.data.data.lender_list,
					'STRING_VAL'
				);
				let lenderItems = responseList.map((response) => ({
					label: response.value,
					value: response.id,
				}));
				if (lenderItems.length === 0) {
					setLeadInfoError(true);
					setLeadInfoErrorMessage('No Lender Found');
				} else {
					setLenders(lenderItems);
					let option1_lead = lenderItems.filter((lenderItems => lenderItems.value == 4))
					let option2_lead = lenderItems.filter((lenderItems => lenderItems.value == 3))
					let option_lead = lenderItems.filter((lenderItems => lenderItems.value != 9))
					if (leadInfo?.cl_lead?.lead_type == 1 && option1_lead[0]?.value == 4) {
						setSelectedLender(option1_lead[0].value);
						setSelectedLenderName(option1_lead[0].label);
					} else if (leadInfo?.cl_lead?.lead_type == 2 && option2_lead[0]?.value == 3) {
						setSelectedLender(option2_lead[0].value);
						setSelectedLenderName(option2_lead[0].label);
					} else if ((option_lead || []).length) {
						setSelectedLender(option_lead[0].value);
						setSelectedLenderName(option_lead[0].label);
					} else {
						setSelectedLender(lenderItems[lenderItems?.length - 1].value);
						setSelectedLenderName(lenderItems[lenderItems?.length - 1].label);
					}
				}
				setLenderInfoLoading(false);
			}
		} catch (err) {
			setLeadInfoError(true);
			setLeadInfoErrorMessage('Server side error occured');
			setLenderInfoLoading(false);
		}
	};

	React.useEffect(() => {
		const currentLenderStatus = (leadInfo?.cl_lead_status || []).find(
			(status) => status.lender_id == selectedLender
		);
		const canViewAdditionalInfo =
			state.userType === 'admin'
				? leadInfo?.is_additional_info_req !== 2
				: leadInfo?.show_additional_info !== 0;
		const canAddPayToCustomer =
			state.userType === 'admin'
				? leadInfo?.is_ptc_enable === 1
				: false;
		const canAddPayToBank =
			state.userType === 'admin'
				? leadInfo?.is_ptb_enable === 1
				: false;
		const checkIsBTCase =
			state.userType === 'admin'
				? leadInfo?.is_bt_case === 1
				: false;
		let viewPages = [];
		if (location.pathname.includes('post-disbursal')) {
			viewPages = [
				checkHasPermission('repayment-details') && {
					component: RepaymentDetails,
					path: '/repayment-details',
					title: 'Repayment Details',
					private: false,
				},
				checkHasPermission('repayment-schedule') && {
					component: RepaymentSchedule,
					path: '/repayment-schedule',
					title: 'Repayment Schedule',
					private: false,
					customComponentProps: {
						selectedLender: selectedLender,
						selectedLenderName: selectedLenderName,
					}
				},
				checkHasPermission('repayment-soa-documents') && {
					component: Documents,
					path: '/soa-documents',
					title: 'Statements',
					private: false,
					customComponentProps: {
						getLeadDetail: getLeadDetail,
						selectedLender: allSelected ? 0 : selectedLender,
						selectedLenderName: allSelected ? '' : selectedLenderName,
						cl_lead_lender_status: currentLenderStatus,
						isPostDisbursalCase: true
					}
				}
			];
		} else {
			viewPages = [
				checkHasPermission('details-info') && {
					component: Details,
					path: '/details',
					title: 'Details',
					private: true,
				},
				checkHasPermission('documents') && {
					component: Documents,
					path: '/documents',
					title: 'Documents',
					private: true,
					customComponentProps: {
						getLeadDetail: getLeadDetail,
						selectedLender: allSelected ? 0 : selectedLender,
						selectedLenderName: allSelected ? '' : selectedLenderName,
						cl_lead_lender_status: currentLenderStatus,
						leadInfo: leadInfo
					},
				}
			];
			if (
				(!canViewAdditionalInfo &&
					location.pathname.includes('additional') || !canAddPayToCustomer &&
					location.pathname.includes('paytocustomer') || !canAddPayToBank &&
					location.pathname.includes('paytobank')) &&
				state.userType === 'admin'
			) {
				navigate(`/portfolio/view/${portfolioId}/details`);
			}
			if (currentLenderStatus) {
				viewPages = [
					...viewPages,
					...(currentLenderStatus?.id > 1 && canViewAdditionalInfo
						? [
							checkHasPermission('additional-info') && {
								component: AdditionalInformation,
								path: '/additional',
								title: 'Additional Information',
								private: true,
								customComponentProps: {
									getLeadDetail: getLeadDetail,
									isAdditionalInfoRequired: leadInfo?.is_additional_info_req,
									showAdditionalInfo: leadInfo?.is_additional_info_req,
									cl_lead_lender_status: currentLenderStatus?.id,
									selectedLender: selectedLender,
									selectedLenderName: selectedLenderName,
								}
							}
						]
						: []),

					...(currentLenderStatus?.id > 3 &&
						currentLenderStatus?.id !== 1
						? [
							checkHasPermission('queries') && {
								component: QueryList,
								path: '/queries',
								title: 'Queries',
								private: true,
								customComponentProps: {
									selectedLender: selectedLender,
									selectedLenderName: selectedLenderName,
								}
							},
							checkHasPermission('queries') && {
								component: QueryList,
								path: '/queries/:queryId',
								private: true,
								customComponentProps: {
									selectedLender: selectedLender,
									selectedLenderName: selectedLenderName,
								}
							}
						]
						: []),

					...([6,9,10,11,15,18,19,20].includes(currentLenderStatus?.id)
						? [
							checkHasPermission('drf-info') && !(leadInfo?.tab_config || []).includes('drf-info') && {
								component: DRF,
								path: '/drf-info',
								title: 'DRF',
								private: true,
								customComponentProps: {
									selectedLender: allSelected ? 0 : selectedLender,
									selectedLenderName: allSelected ? '' : selectedLenderName,
									cl_lead_lender_status: currentLenderStatus,
									leadInfo: leadInfo
								},
							},
							checkHasPermission('mandate-info') && selectedLender == '22' && {
								component: Mandate,
								path: '/mandate-info',
								title: 'Mandate',
								private: true,
								customComponentProps: {
									selectedLender: allSelected ? 0 : selectedLender,
									selectedLenderName: allSelected ? '' : selectedLenderName,
									cl_lead_lender_status: currentLenderStatus,
									leadInfo: leadInfo,
									lafNumber: LAF
								},
							},
							checkHasPermission('repayment-schedule') && {
								component: RepaymentSchedule,
								path: '/repayment',
								title: 'Repayment Schedule',
								private: true,
								forAdmin: true,
								customComponentProps: {
									selectedLender: selectedLender,
									selectedLenderName: selectedLenderName,
								}
							}
						]
						: []),
					...([6,9,10,11,15,18,19,20].includes(currentLenderStatus?.id)
						? [

							checkHasPermission('fundouts') && ((selectedLender == '22' && [10].includes(currentLenderStatus?.id)) || selectedLender != '22') && !(leadInfo?.tab_config || []).includes('fundouts') && {
								component: FundOut,
								path: '/fundout',
								title: 'UTR',
								private: true,
								forAdmin: true,
								customComponentProps: {
									selectedLender: allSelected ? 0 : selectedLender,
									selectedLenderName: allSelected ? '' : selectedLenderName,
									leadInfo: leadInfo,
									lafNumber: LAF
								}
							},
							checkHasPermission('payto-bank-customer') && selectedLender == '16' && canAddPayToBank && {
								component: PayToCustomer,
								path: '/paytobank',
								title: 'Pay To Bank',
								private: true,
								forAdmin: true,
								customComponentProps: {
									paytype: "Bank",
									isBtCase: checkIsBTCase
								}
							},
							checkHasPermission('payto-bank-customer') && selectedLender == '16' && canAddPayToCustomer && {
								component: PayToCustomer,
								path: '/paytocustomer',
								title: 'Pay To Customer',
								private: true,
								forAdmin: true,
								customComponentProps: {
									paytype: "Customer",
									isBtCase: checkIsBTCase
								}
							}
						]
						: []),
					...([6,9,10,11,15,18,19,20].includes(currentLenderStatus?.id)
						? [
							// checkHasPermission('lender-demand') && {
							// 	component: LenderDemand,
							// 	title: 'Lender Demand',
							// 	path: '/lender-demand',
							// 	forAdmin: true,
							// }
						]
						: []),
					...(leadInfo?.cl_lead?.lead_type == 1 && currentLenderStatus?.id > 1 && leadInfo?.cl_lead?.application_status === 'Pre-Sanctioned'
						? [
							// checkHasPermission('conditional-approve') && {
							// 	component: ConditionalApprove,
							// 	path: "/conditional-approve",
							// 	title: "Conditional Approve",
							// 	private: true,
							// 	customComponentProps: {
							// 		selectedLender: allSelected ? 0 : selectedLender,
							// 		selectedLenderName: allSelected ? "" : selectedLenderName,
							// 	},
							// }
						]
						: []),
				];
			}
			viewPages = [
				...viewPages,
				checkHasPermission('audit-trail') && {
					component: AuditTrail,
					path: '/audit-trail',
					title: 'Audit Trail',
					private: true,
					customComponentProps: {
						selectedLender: selectedLender,
						selectedLenderName: allSelected ? '' : selectedLenderName,
					},
				}
			]
		}
		setViewPage(viewPages);
	}, [leadInfo, allSelected, location.pathname]);

	const updateLeadDetail = (leadInfo) => {
		setLeadInfo(leadInfo);
	};

	// React.useEffect(() => {
	// 	if (
	// 		state.userType === 'admin' &&
	// 		location.pathname.includes('audit-trail')
	// 	) {
	// 		toggleAllSelection(true);
	// 	} else {
	// 		toggleAllSelection(false);
	// 	}
	// }, [location.pathname]);

	const toggleAssignModal = () => {
		setAssignModalState(!assignModalState);
	};
	const togglePullBackModal = () => {
		setShowPullBackConfirm(!showPullBackConfirm);
	};
	const toggleRejectModal = () => {
		setShowRejectModal(!showRejectModal);
	};
	const checkHasPermission = (checkPermission) => {
		if (state.is_super_admin === 1) return true;
		const permission = state.permission.find(
			(permission) => permission === checkPermission
		);

		if (permission) return true;
		else return false;
	};
	const findlafId = async () => {
		try {
			let response = await MasterDataService.getLAF(
				'admin',
				'co-lender',
				portfolioId
			)
			setLAF(response.data.data.lead.laf_id)
		} catch (error) {
			console.log(error)
		}
	}
	React.useEffect(() => {
		findlafId()
	}, [])

	const handleFetchData = async (mapCall = false) => {

		setFetchLoader(true)
		try {
			let response = await MasterDataService.fetchLafData(
				'admin',
				'co-lender',
				portfolioId
			)
			if (response?.data?.status?.code == 1) {
				toast.success(`${response?.data?.messages?.success?.others?.[0]}`)
			}
			setFetchLoader(false)
		} catch (error) {
			toast.error(`${error?.response?.data?.messages?.success?.others?.[0]}`)
			setFetchLoader(false)
		}
	}

	const lenderLeadStatus = ()=>{
		let lender_obj = (leadInfo?.cl_lead_status || [])?.filter(status => status?.lender_id == selectedLender)?.[0];
		let alias_name = lender_obj?.alias_name?.[selectedLender];
		if(leadInfo?.cl_lead_status && alias_name){
			return alias_name;
		}else if(leadInfo?.cl_lead_status && lender_obj?.admin_status){
			return lender_obj?.admin_status; 
		}else{
			return 'Unassigned';
		}
	}

	return (

		pageLoader ?
			<div className='viewPortfolioPageLoader'>
				< div className='Tableloader' />
			</div >
			:
			<PortfolioContainer>
				<div className='row'>
					<div className='row no-gutters col-md-12 mb-3  p-2' style={{
						border: "1px solid #d5d5d5", borderBottom: "none", borderRadius: "4px", background: 'rgb(237,235,235)',
						background: 'linear-gradient(90deg, rgb(249,245,242) 0%, rgb(249,245,242) 39%, rgb(249,245,242) 3%, rgba(241,249,255,1) 100%)'
					}}>
						<div className='d-flex justify-content-between col-md-12'>
							<div className='d-flex'>
								{LAF && <div className='mr-1'>
									<div style={{ fontWeight: 600, fontSize: "12px", padding: "4px 16px 4px 6px", color: "#4A4E88", borderRadius: "0px", borderRight: '1px solid #8A8A8A' }}><span style={{ color: "black" }}>LAF : </span>{`${LAF}`}</div>
								</div>}
								<div className='ml-2' style={selectedLender ? { borderRight: "1px solid #8A8A8A" } : { border: "none" }}>
									<div style={{ fontWeight: 600, fontSize: "12px", padding: "4px 16px 4px 6px", borderRadius: "6px", color: "#4A4E88" }}><span style={{ color: "black" }}>Current Status :  </span>
										<span style={{ border: "1px solid", borderRadius: "5px", padding: "2px 6px" }}>{lenderLeadStatus()}</span></div>
								</div>
								<div className='lender-dropdown' key={selectedLender}>
									{
										// console.log("Lenders ", lenders, "selectedLender ", selectedLender, "allselected ", allSelected)
									}
									{
										lenders.length > 0 && <div className='d-flex ml-2' style={{ display: 'flex', alignItems: 'center', background: "", borderRadius: "6px" }}>
											<div style={{ fontWeight: 600, fontSize: "12px", padding: "4px 6px 4px 6px", color: "black", borderRadius: "6px" }}>Lender Name :</div>
											<div style={{ padding: "0 6px 0 0" }}>
												<div className=''>
													<div className='lender_dropdown'>
														{(
															<select style={{ border: "1px solid #4A4E88 " }}
																value={allSelected ? 0 : selectedLender}
																onChange={(e) => {
																	if (e.target.value == 0) {
																		toggleAllSelection(true);

																		setQuerylenderId(0);
																	} else {
																		setSelectedLender(e.target.value);

																		setQuerylenderId(e.target.value);
																		let selectedLenderName = lenders.find((lender) => {
																			return lender.value === e.target.value;
																		});
																		setSelectedLenderName(selectedLenderName.label);
																		toggleAllSelection(false);
																	}
																}}
																className='form-control'
																placeholder=''
															>
																{
																	(lenders || []).map((lender) => (
																		<option key={lender.value} value={lender.value}>
																			{lender.label}
																		</option>
																	))}
															</select>
														)}
													</div>
												</div>
											</div>
										</div>
									}
								</div>
							</div>
							<div className='d-flex  justify-content-start align-items-center ml-1'>
								{!((selectedColender || [])?.includes('/da/')) && (!location.pathname.includes('post-disbursal') && !selectedLender || (![6,9,10,15,18,19,20].includes(leadInfo?.cl_lead_lender_status))) && checkHasPermission('assign-colender-lead') &&
									<button className='mr-2 btn btn-blueButton'
										onClick={toggleAssignModal}

									>
										<span>
											<i class="fa fa-link fa-rotate-270 mr-1" aria-hidden="true"></i>
										</span>
										Map Lender
									</button>
								}
								{selectedLender && <div>
									{(
										!((selectedColender || [])?.includes('/da/')) &&
										!([6, 8, 9, 10, 11, 15, 18, 19]?.includes(leadInfo?.cl_lead_lender_status) ||
											(selectedLenderName || []).includes('Ugro Capital'))) &&
										checkHasPermission('pulled-back-application') && (
											<button
												onClick={togglePullBackModal}
												className='btn btn-blueButton mr-2'
											>
												<i class="fa fa-indent mr-1" aria-hidden="true"></i>
												Pull Back
											</button>
										)}
								</div>}
							</div>
						</div>
					</div>
					<div className='row justify-content-between no-gutters col-md-12 mb-2'>
						<div className='d-flex'>
							{
								(leadInfo == undefined || showFetchBtn) && checkHasPermission("update-data-acc-dump-info") &&
								<Button
									clickHandler={handleFetchData}
									type='btn-outline-custom'
								>
									{fetchLoader ? <div className="loader"></div> : 'Fetch Data'}
								</Button>
							}
							<div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', position: "fixed", top: "20px", cursor: "pointer", left: state.sidebarOpen ? "235px" : "60px" }} onClick={() => navigate(selectedColender)}>
								<div style={{ border: "1px solid #4A4E88", borderRadius: "50%", color: "#4A4E88", padding: "1px 1px 1px 5px", justifyContent: "center", alignItems: "center", marginRight: "2px" }}>
									<i className='fa fa-chevron-left mr-1'></i>
								</div>
								<Link style={{ textDecoration: "underline", color: "#4A4E88", fontWeight: "600" }}>BACK</Link>
							</div>
						</div>
						{/* {!location.pathname.includes('post-disbursal') && !selectedLender && checkHasPermission('assign-colender-lead') && <button class='btn btn-custom ml-2' onClick={toggleAssignModal}>
						Map Co-Lender
					</button>} */}

						{location.pathname.includes('post-disbursal') && checkHasPermission("details-info") &&
							<div style={{ cursor: 'pointer', color: '#007bff', fontSize: 16, marginRight: location.pathname.includes('soa-documents') ? 15 : 5 }} onClick={() => {
								dispatch({
									type: 'selectedColender',
									selectedColender: '/portfolio/disbursal-approved',
								});
								localStorage.setItem('selectedColender', '/portfolio/disbursal-approved');
								navigate(`/portfolio/view/${portfolioId}/details`);
							}}
							>
								Check Application Details
							</div>}

						{!((selectedColender || [])?.includes('/da/')) && !location.pathname.includes('post-disbursal') && leadInfo && leadInfo.cl_lead_lender_status !== 11 && (
							<PortfolioActions
								state={state}
								detailsResponse={leadInfo}
								detailLenderId={selectedLender}
								detailLenderName={selectedLenderName}
								updateLeadDetail={updateLeadDetail}
								toggleAssignModalMapLender={toggleAssignModal}

							/>
						)}

						{!location.pathname.includes('post-disbursal') && state.userType !== 'lender' && assignModalState ? (
							<AssignLenderLeadModal
								title={'Map Co-Lender'}
								modelState={assignModalState}
								toggleModal={toggleAssignModal}
								reloadTable={(lenderId) => getLeadDetail()}
								colenders={[]}
								selectedIds={[portfolioId]}
								leadType={leadInfo?.cl_lead?.cl_lead_id || ''}
								getLenderList={getLenderList}
								type='details'
								getLeadDetail={(lenderId) => getLeadDetail()}
								fetchLafData={() => handleFetchData(true)}
							/>
						) : (
							''
						)}
						{showPullBackConfirm && (
							<PullBackModal
								modelState={showPullBackConfirm}
								toggleModal={togglePullBackModal}
								getLeadDetail={getLeadDetail}
								toggleRejectModal={toggleRejectModal}
								leadType={leadInfo?.cl_lead?.lead_type || ''}
							/>
						)}
					</div>
					<div className='col-12'>
						<ViewTabs
							portfolioId={portfolioId}
							tabs={viewPage.filter(({ title }) => title)}
						/>
						<hr style={{ marginTop: '-4.5px' }} />
					</div>

					<div class='col-md-12'>
						<Routing routes={viewPage} />
					</div>
				</div>
			</PortfolioContainer>
	);
}
